import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'

function getSessionId(): string {
  let sessionId = localStorage.getItem('ca-session-id')
  if (!sessionId) {
    sessionId = crypto.randomUUID?.() ||
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    localStorage.setItem('ca-session-id', sessionId)
  }
  return sessionId
}

function getUserAgentHash(): string {
  const ua = navigator.userAgent
  let hash = 0
  for (let i = 0; i < ua.length; i++) {
    const char = ua.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash
  }
  return hash.toString()
}

export function trackPageView(pagePath: string, newsId?: string) {
  const sessionId = getSessionId()
  const userAgentHash = getUserAgentHash()
  const referrer = document.referrer || null

  // Use setTimeout to not block page load
  setTimeout(() => {
    supabase.from('page_views').insert({
      page_path: pagePath,
      news_id: newsId || null,
      session_id: sessionId,
      referrer: referrer,
      user_agent_hash: userAgentHash,
    }).then(({ error }) => {
      if (error) {
        console.error('Error tracking page view:', error.message)
      }
    })
  }, 100)
}

export function useAnalytics(pagePath: string, newsId?: string) {
  useEffect(() => {
    trackPageView(pagePath, newsId)
  }, [pagePath, newsId])
}

export function useNewsAnalytics(newsId: string, slug?: string) {
  useEffect(() => {
    if (!newsId) return
    trackPageView(slug ? `/noticias/${slug}` : `/noticias/${newsId}`, newsId)
    setTimeout(() => {
      supabase.rpc('increment_news_views', { news_id: newsId }).then(({ error }) => {
        if (error) {
          console.error('Error incrementing news views:', error.message)
        }
      })
    }, 200)
  }, [newsId, slug])
}
